module.exports = __webpack_public_path__ + "img/change.54de08aa.gif";